import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessCategorySchema, ProcessStatusSchema } from '../../entities/process';
import { CapacityBindingSchema } from '../../shared/capacity';
import { ProcessCapabilitySchema } from '../../shared/authorization';
/**
 * List All Processes Request Schema
 * GET /api/v2/processes
 * No request body required
 */ export const ListAllProcessesRequestSchema = z.void();
/**
 * Process List Stats Schema
 * Computed statistics for a process in the list view
 */ export const ProcessListStatsSchema = z.object({
    totalSteps: z.number(),
    userInvolvedSteps: z.number(),
    averageRating: z.number().nullable()
});
// `lastEditedBy` is null when the editor is unknown (drafts edited before
// tracking) or hard-deleted.
export const ProcessListDraftSchema = z.object({
    lastEditedAt: z.string(),
    lastEditedBy: z.object({
        _id: z.string(),
        firstName: z.string(),
        lastName: z.string()
    }).nullable()
});
/**
 * Process List Row Schema
 *
 * The wire shape of ONE row of `GET /api/v2/process`. Standalone, not a
 * narrowing of the full process: the listing ships the fields the table and the
 * dialogs opened from it read, and nothing else — no `createdBy`, no avatars,
 * no populated org functions, no accountable department.
 *
 * `owner` and `accountable` carry ids plus the few display/seed fields their
 * consumers need (the process form seeds owner/accountable ids, the
 * initial-setup import seeds both e-mails), which is why they are object
 * literals here instead of `PopulatedUserSchema`.
 */ export const ProcessListRowSchema = z.object({
    _id: z.string(),
    name: z.string(),
    description: z.string(),
    category: ProcessCategorySchema.optional(),
    apqcEquivalentId: z.string().optional(),
    createdAt: z.string().optional(),
    status: ProcessStatusSchema,
    // Both refs populate to null when they dangle, so null must parse.
    department: z.object({
        _id: z.string(),
        name: z.string()
    }).nullish(),
    owner: z.object({
        _id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        email: z.string()
    }).nullish(),
    accountable: z.object({
        _id: z.string(),
        email: z.string()
    }).nullish(),
    stats: ProcessListStatsSchema,
    capacityBinding: CapacityBindingSchema.nullable(),
    capabilities: ProcessCapabilitySchema,
    // Null unless an open draft carries edits.
    draft: ProcessListDraftSchema.nullable()
});
/**
 * List All Processes Response Schema
 * Returned on successful retrieval
 * Contains array of all process list rows with computed stats
 */ export const ListAllProcessesResponseSchema = z.object({
    processes: z.array(ProcessListRowSchema)
});
/**
 * List All Processes Error Schema
 * Returned when retrieval fails
 */ export const ListAllProcessesErrorSchema = BaseErrorSchema;

//# sourceMappingURL=list-all-processes.schema.js.map